import { useTranslations } from "adapters/i18n";
import React, { useCallback } from "react";
import TextoInfoFarol from "../TextoInfoFarol";

export type FarolPastoFezes = {
  CategoriaAnimal: string | null;
  Cor: string | null;
  DataOperacao: string | null;
  IdPasto: number;
  Quantidade: number | null;
  TotalReal: number;
  Valor: string | null;
};

export const MontaTextoTooltipFezes = (
  title: string,
  farolPasto: FarolPastoFezes
) => {
  const { t } = useTranslations();

  const constants = {
    fezes: t("statusIndicator:stools"),
    data: t("common:date"),
  };

  const textoComponente = useCallback(() => {
    let properties: { [key: string]: [string] } = {};

    if (farolPasto && farolPasto.Cor) {
      const fezes = farolPasto.Valor;
      const hasQuantity =
        farolPasto.Quantidade &&
        farolPasto.CategoriaAnimal &&
        farolPasto.DataOperacao;

      let nHeads: number | null = 0;
      let nHeadsLabel = "";
      if (hasQuantity) {
        nHeads =
          farolPasto.TotalReal > 0
            ? farolPasto.TotalReal
            : farolPasto.Quantidade;
        nHeadsLabel = `${nHeads}cab`;
      }

      properties = {
        ...(fezes ? { [constants.fezes]: [fezes] } : {}),
        ...(hasQuantity ? { [constants.data]: [farolPasto.DataOperacao] } : {}),
        ...(hasQuantity ? { _: [nHeadsLabel] } : {}),
      };
    }

    properties = {
      ...properties,
    };

    return (
      <TextoInfoFarol
        title={title}
        properties={properties}
        titleAdornmentColor={""}
      />
    );
  }, [title, farolPasto]);

  return () => textoComponente();
};
